import React from "react";

interface ExamTimeLimitToastProps {
  open: boolean;
  onClose: () => void;
  message?: string;
}

const ExamTimeLimitToast: React.FC<ExamTimeLimitToastProps> = ({
  open,
  onClose,
  message = "5 minutes left in this part of the test.",
}) => {
  if (!open) return null;
  return (
    <div className="fixed top-16 left-1/2 z-50 -translate-x-1/2 bg-neutral-900 text-white px-6 py-3 rounded-xl shadow-lg flex items-center gap-3 animate-fade-in">
      <span>{message}</span>
      <button
        className="ml-2 text-white/70 hover:text-white text-lg font-bold focus:outline-none cursor-pointer"
        onClick={onClose}
        aria-label="Close"
      >
        ×
      </button>
    </div>
  );
};

export default ExamTimeLimitToast;
